/** @jsx jsx */
import { Fragment, h } from 'preact';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { Prices } from '../../Prices/Prices';

// CSS
import '../../Result/result.css';

export function TypeAheadCustomBundleProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

	const context = getContext(['region']);
	const core = result?.mappings?.core;
	const priceRange = result?.attributes?.ss_price_range ? "sale-price" : "no-sale-price";

	// Handle fr product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result', `ss__result--${layout}`, className)}>
			<a
				href={productUrl} //No variant selection on PLP, so extra logic not needed here.
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						<div {...styling} className={classnames('ss__image', 'ss__result__image')}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.4967637540453074"
								data-sizes="auto"
								data-image
								src={core.imageUrl}
							/>
						</div>
					</div>
					<div className="ss__result__details">
						{core.name && (
							<div>
								<div className="ss__result__details__title body-medium">{core.name}</div>
								<div className={`ss__result__details__pricing ${priceRange}`}>
									{context.region == 'us' && <Prices core={core} subProps={parentSubProps} />}

									{context.region == 'ca' && <Prices core={core} subProps={parentSubProps} />}

									{context.region == 'uk' && window.Resources.marketHandle == 'uk' && (
										<Prices core={core} subProps={parentSubProps} />
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			</a>
		</article>
	);
}
